import React, { useState } from 'react';
import { Document, Page, pdfjs } from "react-pdf";
import "../style/pdf.css";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
//import 'react-pdf/dist/Page/TextLayer.css';

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`;

function VisorPDF({ archivo }) {
    const [numPages, setNumPages] = useState(null);
    const [pageNumber, setPageNumber] = useState(1);
    const [scale, setScale] = useState(0.7);
  
    const onDocumentLoadSuccess = ({ numPages }) => setNumPages(numPages);
    const zoomIn = () => {
      // Asegura que el zoom no exceda el 100% (scale = 1.0)
      const newScale = scale + 0.2 <= 1.0 ? scale + 0.2 : 1.0;
      setScale(newScale);
    };
    const zoomOut = () => setScale(scale > 0.4 ? scale - 0.2 : scale);
    const goToPrevPage = () => setPageNumber(pageNumber > 1 ? pageNumber - 1 : 1);
    const goToNextPage = () =>
      setPageNumber(pageNumber < numPages ? pageNumber + 1 : numPages);
  
    return (
      <div className="pdf-container">
        <div className="toolbar">
          <button onClick={goToPrevPage}>{"<"}</button>
          <span>
            {pageNumber} / {numPages}
          </span>
          <button onClick={goToNextPage}>{">"}</button>
          <button onClick={zoomOut}>-</button>
          <input
            type="text"
            value={Math.round(scale * 100) + '%'}
            readOnly
          />
          <button onClick={zoomIn}>+</button>
        </div>
        <div className="document-container">
          <Document file={archivo} onLoadSuccess={onDocumentLoadSuccess}>
            <Page pageNumber={pageNumber} scale={scale} /> 
          </Document>
        </div>
      </div>
    );
  }

  export default VisorPDF;